export default __webpack_public_path__ + "static/media/bg2.58b0c7d3.svg";